export type BarcodeFormat = 
  | 'QR_CODE'
  | 'CODE_128'
  | 'CODE_39'
  | 'EAN_13'
  | 'EAN_8'
  | 'UPC_A'
  | 'UPC_E'
  | 'ITF'
  | 'CODABAR'
  | 'DATA_MATRIX'
  | 'PDF_417'
  | 'UNKNOWN';

export interface ScanResult {
  text: string;
  format: BarcodeFormat;
  timestamp: number;
  isValidTracking?: boolean;
  trackingInfo?: {
    carrier: string;
    format: string;
    description: string;
  };
}

export interface CameraScannerProps {
  isOpen: boolean;
  onClose: () => void;
  onScanSuccess: (result: ScanResult) => void;
  onScanError?: (error: string | undefined) => void;
  timeoutMs?: number;
  enableBarcodeScanning?: boolean;
  validateAustraliaPost?: boolean;
}

export interface CameraScanButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
}

export enum ScannerState {
  IDLE = 'idle',
  INITIALIZING = 'initializing',
  SCANNING = 'scanning',
  SUCCESS = 'success',
  ERROR = 'error',
  PERMISSION_DENIED = 'permission_denied',
  NO_CAMERA = 'no_camera'
}

export interface CameraError {
  code: string;
  message: string;
  userMessage: string;
}

export interface ScannerEngine {
  name: 'qr-scanner' | 'zxing';
  supports: BarcodeFormat[];
}